import React from 'react'

import motionAnimation from 'assets/animations/motion.json'
import interactivityAnimation from 'assets/animations/interactivity.json'
import energyAnimation from 'assets/animations/energy.json'

import FeatureCard from './FeatureCard'

const FEATURE_CARDS = [
  { name: 'interactivity', animationData: interactivityAnimation },
  { name: 'motion', animationData:  motionAnimation },
  { name: 'energy', animationData: energyAnimation }
]

function Features() {
  return (
    <div className="features">
      {FEATURE_CARDS.map((feature, index) => (
        <FeatureCard
          key={`features-${feature.name}`}
          animationData={feature.animationData}
          name={feature.name}
          index={index}
        />
      ))}
    </div>
  )
}

export default Features
